import { useEffect } from 'react';

const ChatwootButton = () => {
  useEffect(() => {
    // Add custom styles
    const style = document.createElement('style');
    style.textContent = `
      .woot-widget-bubble {
        bottom: 70px !important;
        opacity: 0.8 !important;
      }
      [data-theme="dark"] .woot-widget-bubble,
      .dark .woot-widget-bubble,
      [class*="dark"] .woot-widget-bubble {
        background-color: #10b981 !important;
        opacity: 0.95 !important;
      }
      [data-theme="dark"] .woot-widget-bubble:hover,
      .dark .woot-widget-bubble:hover,
      [class*="dark"] .woot-widget-bubble:hover {
        background-color: #059669 !important;
        opacity: 1 !important;
      }
      [data-theme="dark"] .woot-widget-bubble img,
      .dark .woot-widget-bubble img,
      [class*="dark"] .woot-widget-bubble img {
        filter: brightness(0) invert(1) !important;
      }
    `;
    document.head.appendChild(style);

    (function (d, t) {
      window.chatwootSettings = {
        type: 'expanded_bubble',
        style: 'flat',
        position: 'right',
        launcherTitle: 'Help',
      };
      var BASE_URL = 'https://app.chatwoot.com';
      var g = d.createElement(t),
        s = d.getElementsByTagName(t)[0];
      g.src = BASE_URL + '/packs/js/sdk.js';
      g.defer = true;
      g.async = true;
      s.parentNode.insertBefore(g, s);
      g.onload = function () {
        window.chatwootSDK.run({
          websiteToken: 'vXcYZsTTPiXAGejo2VguPZHR',
          baseUrl: BASE_URL,
        });
      };
    })(document, 'script');

    // Cleanup function
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return null;
};

export default ChatwootButton;
